module.exports = __webpack_public_path__ + "static/media/IPER.7beda6ce.svg";